module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid40_1080x902.36ed51f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid40_1080x902.jpg
// module id = t5Zv
// module chunks = 0